export const SearchSvgIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M7.66536 13.9987C11.1632 13.9987 13.9987 11.1632 13.9987 7.66536C13.9987 4.16756 11.1632 1.33203 7.66536 1.33203C4.16756 1.33203 1.33203 4.16756 1.33203 7.66536C1.33203 11.1632 4.16756 13.9987 7.66536 13.9987Z"
      stroke="#868686"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.6654 14.6654L13.332 13.332"
      stroke="#868686"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const PlusWithBorderSvgIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M6.66675 10H13.3334"
      stroke="#FFF"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 13.3333V6.66666"
      stroke="#FFF"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.50008 18.3333H12.5001C16.6667 18.3333 18.3334 16.6667 18.3334 12.5V7.49999C18.3334 3.33332 16.6667 1.66666 12.5001 1.66666H7.50008C3.33341 1.66666 1.66675 3.33332 1.66675 7.49999V12.5C1.66675 16.6667 3.33341 18.3333 7.50008 18.3333Z"
      stroke="#FFF"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const CampaignSentSvgIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M21.2468 17.8385L19.6168 18.3885C19.1668 18.5385 18.8068 18.8885 18.6568 19.3485L18.1068 20.9785C17.6368 22.3885 15.6568 22.3585 15.2168 20.9485L13.3668 14.9985C13.0068 13.8185 14.0968 12.7185 15.2668 13.0885L21.2268 14.9385C22.6268 15.3785 22.6468 17.3685 21.2468 17.8385Z"
      stroke="#868686"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M22.2852 12C22.2852 6.48 17.8052 2 12.2852 2C6.76516 2 2.28516 6.48 2.28516 12C2.28516 17.52 6.76516 22 12.2852 22"
      stroke="#868686"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const CampaignOpenedSvgIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M7.57031 12C3.57031 12 3.57031 13.79 3.57031 16V17C3.57031 19.76 3.57031 22 8.57031 22H16.5703C20.5703 22 21.5703 19.76 21.5703 17V16C21.5703 13.79 21.5703 12 17.5703 12C16.5703 12 16.2903 12.21 15.7703 12.6L14.7503 13.68C13.5703 14.94 11.5703 14.94 10.3803 13.68L9.37031 12.6C8.85031 12.21 8.57031 12 7.57031 12Z"
      stroke="#868686"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.5703 12V6C19.5703 3.79 19.5703 2 15.5703 2H9.57031C5.57031 2 5.57031 3.79 5.57031 6V12"
      stroke="#868686"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const CampaignClickedSvgIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M12.857 14.8794C11.947 14.8794 11.207 14.1394 11.207 13.2294V10.7594C11.207 9.8494 11.947 9.10938 12.857 9.10938C13.767 9.10938 14.507 9.8494 14.507 10.7594V13.2294C14.507 14.1394 13.767 14.8794 12.857 14.8794Z"
      stroke="#868686"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M17.8355 13.4697C17.6355 16.0497 15.4755 18.0697 12.8555 18.0697C10.0955 18.0697 7.85547 15.8297 7.85547 13.0697V10.9297C7.85547 8.16969 10.0955 5.92969 12.8555 5.92969C15.4455 5.92969 17.5755 7.89968 17.8255 10.4197"
      stroke="#868686"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M15.8555 2H17.8555C20.8555 2 22.8555 4 22.8555 7V9"
      stroke="#868686"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.85547 9V7C2.85547 4 4.85547 2 7.85547 2H9.85547"
      stroke="#868686"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.8555 22H17.8555C20.8555 22 22.8555 20 22.8555 17V15"
      stroke="#868686"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.85547 15V17C2.85547 20 4.85547 22 7.85547 22H9.85547"
      stroke="#868686"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const CampaignRepliedSvgIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M10.4523 13.6914L15.2984 8.84522M20.2558 5.8877L16.1652 19.1823C15.7986 20.3737 15.6152 20.9697 15.299 21.1673C15.0247 21.3386 14.6852 21.3673 14.3865 21.2433C14.0421 21.1004 13.7625 20.5423 13.2049 19.427L10.6139 14.2451C10.5254 14.0681 10.4811 13.98 10.422 13.9033C10.3696 13.8353 10.309 13.774 10.241 13.7215C10.166 13.6637 10.0794 13.6204 9.9103 13.5359L4.71645 10.939C3.60115 10.3813 3.04345 10.1022 2.90054 9.75781C2.7766 9.45912 2.80486 9.11925 2.97622 8.845C3.17381 8.52876 3.76976 8.34505 4.96157 7.97834L18.2562 3.8877C19.1931 3.5994 19.6618 3.45537 19.9783 3.57155C20.2539 3.67275 20.4712 3.88986 20.5724 4.16553C20.6886 4.48185 20.5444 4.95029 20.2564 5.88631L20.2558 5.8877Z"
      stroke="#868686"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const OutlookSvgIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="45"
    height="46"
    viewBox="0 0 48 48"
  >
    <path
      fill="#1a237e"
      d="M43.607,23.752l-7.162-4.172v11.594H44v-6.738C44,24.155,43.85,23.894,43.607,23.752z"
    ></path>
    <path
      fill="#0c4999"
      d="M33.919,8.84h9.046V7.732C42.965,6.775,42.19,6,41.234,6H17.667c-0.956,0-1.732,0.775-1.732,1.732 V8.84h9.005H33.919z"
    ></path>
    <path
      fill="#0f73d9"
      d="M33.919,33.522h7.314c0.956,0,1.732-0.775,1.732-1.732v-6.827h-9.046V33.522z"
    ></path>
    <path
      fill="#0f439d"
      d="M15.936,24.964v6.827c0,0.956,0.775,1.732,1.732,1.732h7.273v-8.558H15.936z"
    ></path>
    <path
      fill="#2ecdfd"
      d="M33.919 8.84H42.964999999999996V16.866999999999997H33.919z"
    ></path>
    <path
      fill="#1c5fb0"
      d="M15.936 8.84H24.941000000000003V16.866999999999997H15.936z"
    ></path>
    <path fill="#1467c7" d="M24.94 24.964H33.919V33.522H24.94z"></path>
    <path
      fill="#1690d5"
      d="M24.94 8.84H33.919V16.866999999999997H24.94z"
    ></path>
    <path
      fill="#1bb4ff"
      d="M33.919 16.867H42.964999999999996V24.963H33.919z"
    ></path>
    <path
      fill="#074daf"
      d="M15.936 16.867H24.941000000000003V24.963H15.936z"
    ></path>
    <path fill="#2076d4" d="M24.94 16.867H33.919V24.963H24.94z"></path>
    <path
      fill="#2ed0ff"
      d="M15.441,42c0.463,0,26.87,0,26.87,0C43.244,42,44,41.244,44,40.311V24.438 c0,0-0.03,0.658-1.751,1.617c-1.3,0.724-27.505,15.511-27.505,15.511S14.978,42,15.441,42z"
    ></path>
    <path
      fill="#139fe2"
      d="M42.279,41.997c-0.161,0-26.59,0.003-26.59,0.003C14.756,42,14,41.244,14,40.311V25.067 l29.363,16.562C43.118,41.825,42.807,41.997,42.279,41.997z"
    ></path>
    <path
      fill="#00488d"
      d="M22.319,34H5.681C4.753,34,4,33.247,4,32.319V15.681C4,14.753,4.753,14,5.681,14h16.638 C23.247,14,24,14.753,24,15.681v16.638C24,33.247,23.247,34,22.319,34z"
    ></path>
    <path
      fill="#fff"
      d="M13.914,18.734c-3.131,0-5.017,2.392-5.017,5.343c0,2.951,1.879,5.342,5.017,5.342 c3.139,0,5.017-2.392,5.017-5.342C18.931,21.126,17.045,18.734,13.914,18.734z M13.914,27.616c-1.776,0-2.838-1.584-2.838-3.539 s1.067-3.539,2.838-3.539c1.771,0,2.839,1.585,2.839,3.539S15.689,27.616,13.914,27.616z"
    ></path>
  </svg>
);
export const SmallOutlookSvgIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="24"
    height="26"
    viewBox="0 0 48 48"
  >
    <path
      fill="#1a237e"
      d="M43.607,23.752l-7.162-4.172v11.594H44v-6.738C44,24.155,43.85,23.894,43.607,23.752z"
    ></path>
    <path
      fill="#0c4999"
      d="M33.919,8.84h9.046V7.732C42.965,6.775,42.19,6,41.234,6H17.667c-0.956,0-1.732,0.775-1.732,1.732 V8.84h9.005H33.919z"
    ></path>
    <path
      fill="#0f73d9"
      d="M33.919,33.522h7.314c0.956,0,1.732-0.775,1.732-1.732v-6.827h-9.046V33.522z"
    ></path>
    <path
      fill="#0f439d"
      d="M15.936,24.964v6.827c0,0.956,0.775,1.732,1.732,1.732h7.273v-8.558H15.936z"
    ></path>
    <path
      fill="#2ecdfd"
      d="M33.919 8.84H42.964999999999996V16.866999999999997H33.919z"
    ></path>
    <path
      fill="#1c5fb0"
      d="M15.936 8.84H24.941000000000003V16.866999999999997H15.936z"
    ></path>
    <path fill="#1467c7" d="M24.94 24.964H33.919V33.522H24.94z"></path>
    <path
      fill="#1690d5"
      d="M24.94 8.84H33.919V16.866999999999997H24.94z"
    ></path>
    <path
      fill="#1bb4ff"
      d="M33.919 16.867H42.964999999999996V24.963H33.919z"
    ></path>
    <path
      fill="#074daf"
      d="M15.936 16.867H24.941000000000003V24.963H15.936z"
    ></path>
    <path fill="#2076d4" d="M24.94 16.867H33.919V24.963H24.94z"></path>
    <path
      fill="#2ed0ff"
      d="M15.441,42c0.463,0,26.87,0,26.87,0C43.244,42,44,41.244,44,40.311V24.438 c0,0-0.03,0.658-1.751,1.617c-1.3,0.724-27.505,15.511-27.505,15.511S14.978,42,15.441,42z"
    ></path>
    <path
      fill="#139fe2"
      d="M42.279,41.997c-0.161,0-26.59,0.003-26.59,0.003C14.756,42,14,41.244,14,40.311V25.067 l29.363,16.562C43.118,41.825,42.807,41.997,42.279,41.997z"
    ></path>
    <path
      fill="#00488d"
      d="M22.319,34H5.681C4.753,34,4,33.247,4,32.319V15.681C4,14.753,4.753,14,5.681,14h16.638 C23.247,14,24,14.753,24,15.681v16.638C24,33.247,23.247,34,22.319,34z"
    ></path>
    <path
      fill="#fff"
      d="M13.914,18.734c-3.131,0-5.017,2.392-5.017,5.343c0,2.951,1.879,5.342,5.017,5.342 c3.139,0,5.017-2.392,5.017-5.342C18.931,21.126,17.045,18.734,13.914,18.734z M13.914,27.616c-1.776,0-2.838-1.584-2.838-3.539 s1.067-3.539,2.838-3.539c1.771,0,2.839,1.585,2.839,3.539S15.689,27.616,13.914,27.616z"
    ></path>
  </svg>
);

export const GmailSvgIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="45"
    height="46"
    viewBox="0 0 45 46"
    fill="none"
  >
    <path
      d="M23.3151 27.8295L5.46978 16.4731C4.54721 15.863 3.90114 14.9149 3.67071 13.8331C3.44028 12.7513 3.64391 11.6223 4.23776 10.6892C4.8316 9.75603 5.76816 9.09344 6.84575 8.84408C7.92335 8.59471 9.05577 8.77851 9.99917 9.3559L23.0914 17.687L34.8463 9.45828C35.7635 8.8368 36.8882 8.60101 37.9777 8.80185C39.0673 9.00269 40.034 9.62403 40.6693 10.5317C41.3045 11.4393 41.5572 12.5604 41.3729 13.6528C41.1885 14.7452 40.5818 15.7213 39.6838 16.3701L23.3151 27.8295Z"
      fill="#EA4435"
    />
    <path
      d="M38.6719 38.2263H33.0469V12.9138C33.0469 11.7949 33.4913 10.7219 34.2825 9.93071C35.0737 9.13954 36.1467 8.69507 37.2656 8.69507C38.3845 8.69507 39.4576 9.13954 40.2487 9.93071C41.0399 10.7219 41.4844 11.7949 41.4844 12.9138V35.4138C41.4844 36.1597 41.1881 36.8751 40.6606 37.4026C40.1332 37.93 39.4178 38.2263 38.6719 38.2263Z"
      fill="#00AC47"
    />
    <path
      d="M41.4234 12.303C41.411 12.2186 41.412 12.1324 41.3944 12.0482C41.3674 11.9191 41.3172 11.7999 41.2787 11.6753C41.2413 11.5327 41.1963 11.3922 41.1439 11.2544C41.1158 11.1876 41.0725 11.1289 41.0406 11.064C40.9531 10.8765 40.8518 10.6958 40.7377 10.5233C40.6814 10.4416 40.6111 10.3719 40.549 10.2946C40.4423 10.154 40.327 10.0202 40.2037 9.89396C40.1102 9.80297 40.0036 9.7269 39.9019 9.64491C39.7939 9.55226 39.6812 9.46511 39.5644 9.38377C39.4529 9.31093 39.3309 9.25482 39.2129 9.19266C39.0886 9.12783 38.9668 9.05724 38.8374 9.00549C38.7124 8.95515 38.5791 8.92308 38.4484 8.88469C38.3178 8.8463 38.1879 8.80032 38.0537 8.77543C37.8875 8.74873 37.7199 8.73183 37.5517 8.7248C37.4449 8.71735 37.3392 8.69865 37.232 8.69949C37.0331 8.70529 36.8348 8.72526 36.6387 8.75926C36.5596 8.77107 36.4798 8.77008 36.4012 8.7864C36.1359 8.86747 35.8712 8.95092 35.6074 9.03671C35.535 9.06765 35.4715 9.11363 35.4014 9.14851C34.6873 9.48173 34.0849 10.0146 33.6672 10.6829C33.2495 11.3511 33.0342 12.126 33.0475 12.9139V21.0167L39.6849 16.37C40.3368 15.9326 40.8478 15.3156 41.1563 14.5937C41.4647 13.8719 41.5578 13.0764 41.4234 12.303Z"
      fill="#FFBA00"
    />
    <path
      d="M7.73438 8.69507C8.85326 8.69507 9.92631 9.13954 10.7175 9.93071C11.5087 10.7219 11.9531 11.7949 11.9531 12.9138V38.2263H6.32812C5.5822 38.2263 4.86683 37.93 4.33939 37.4026C3.81194 36.8751 3.51563 36.1597 3.51562 35.4138V12.9138C3.51563 11.7949 3.9601 10.7219 4.75127 9.93071C5.54244 9.13954 6.61549 8.69507 7.73438 8.69507Z"
      fill="#4285F4"
    />
    <path
      d="M3.5793 12.303C3.59167 12.2186 3.59069 12.1324 3.60827 12.0482C3.63527 11.9191 3.68547 11.7999 3.724 11.6753C3.76135 11.5327 3.80632 11.3923 3.85872 11.2545C3.88684 11.1877 3.93016 11.1291 3.96222 11.0641C4.04966 10.8766 4.15091 10.6958 4.26513 10.5233C4.32138 10.4416 4.39169 10.372 4.45384 10.2946C4.56046 10.154 4.67572 10.0202 4.79894 9.89397C4.89245 9.80298 4.99905 9.7269 5.10086 9.64492C5.20888 9.55224 5.32153 9.46508 5.43836 9.38378C5.54988 9.31094 5.67194 9.25483 5.78992 9.19267C5.91185 9.1237 6.03716 9.06091 6.16539 9.00451C6.29055 8.95417 6.42386 8.92211 6.55436 8.88372C6.68486 8.84533 6.81494 8.79934 6.94909 8.77445C7.1153 8.74776 7.28294 8.73086 7.45113 8.72383C7.558 8.71637 7.66361 8.69767 7.77077 8.69851C7.9697 8.7043 8.16797 8.72428 8.36406 8.75828C8.44324 8.77009 8.52297 8.76911 8.60172 8.78542C8.73784 8.8201 8.87208 8.86178 9.00391 8.9103C9.13647 8.94553 9.26718 8.9874 9.39555 9.03573C9.46783 9.06667 9.53125 9.11265 9.60156 9.14753C9.78385 9.23317 9.95971 9.33186 10.1278 9.44284C10.6912 9.82969 11.1519 10.3478 11.4703 10.9526C11.7887 11.5573 11.955 12.2305 11.9551 12.9139V21.0167L5.31756 16.3703C4.66587 15.9327 4.1549 15.3158 3.84642 14.5939C3.53793 13.8721 3.44515 13.0764 3.5793 12.303Z"
      fill="#C52528"
    />
  </svg>
);
export const SmallGmailSvgIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="26"
    viewBox="0 0 45 46"
    fill="none"
  >
    <path
      d="M23.3151 27.8295L5.46978 16.4731C4.54721 15.863 3.90114 14.9149 3.67071 13.8331C3.44028 12.7513 3.64391 11.6223 4.23776 10.6892C4.8316 9.75603 5.76816 9.09344 6.84575 8.84408C7.92335 8.59471 9.05577 8.77851 9.99917 9.3559L23.0914 17.687L34.8463 9.45828C35.7635 8.8368 36.8882 8.60101 37.9777 8.80185C39.0673 9.00269 40.034 9.62403 40.6693 10.5317C41.3045 11.4393 41.5572 12.5604 41.3729 13.6528C41.1885 14.7452 40.5818 15.7213 39.6838 16.3701L23.3151 27.8295Z"
      fill="#EA4435"
    />
    <path
      d="M38.6719 38.2263H33.0469V12.9138C33.0469 11.7949 33.4913 10.7219 34.2825 9.93071C35.0737 9.13954 36.1467 8.69507 37.2656 8.69507C38.3845 8.69507 39.4576 9.13954 40.2487 9.93071C41.0399 10.7219 41.4844 11.7949 41.4844 12.9138V35.4138C41.4844 36.1597 41.1881 36.8751 40.6606 37.4026C40.1332 37.93 39.4178 38.2263 38.6719 38.2263Z"
      fill="#00AC47"
    />
    <path
      d="M41.4234 12.303C41.411 12.2186 41.412 12.1324 41.3944 12.0482C41.3674 11.9191 41.3172 11.7999 41.2787 11.6753C41.2413 11.5327 41.1963 11.3922 41.1439 11.2544C41.1158 11.1876 41.0725 11.1289 41.0406 11.064C40.9531 10.8765 40.8518 10.6958 40.7377 10.5233C40.6814 10.4416 40.6111 10.3719 40.549 10.2946C40.4423 10.154 40.327 10.0202 40.2037 9.89396C40.1102 9.80297 40.0036 9.7269 39.9019 9.64491C39.7939 9.55226 39.6812 9.46511 39.5644 9.38377C39.4529 9.31093 39.3309 9.25482 39.2129 9.19266C39.0886 9.12783 38.9668 9.05724 38.8374 9.00549C38.7124 8.95515 38.5791 8.92308 38.4484 8.88469C38.3178 8.8463 38.1879 8.80032 38.0537 8.77543C37.8875 8.74873 37.7199 8.73183 37.5517 8.7248C37.4449 8.71735 37.3392 8.69865 37.232 8.69949C37.0331 8.70529 36.8348 8.72526 36.6387 8.75926C36.5596 8.77107 36.4798 8.77008 36.4012 8.7864C36.1359 8.86747 35.8712 8.95092 35.6074 9.03671C35.535 9.06765 35.4715 9.11363 35.4014 9.14851C34.6873 9.48173 34.0849 10.0146 33.6672 10.6829C33.2495 11.3511 33.0342 12.126 33.0475 12.9139V21.0167L39.6849 16.37C40.3368 15.9326 40.8478 15.3156 41.1563 14.5937C41.4647 13.8719 41.5578 13.0764 41.4234 12.303Z"
      fill="#FFBA00"
    />
    <path
      d="M7.73438 8.69507C8.85326 8.69507 9.92631 9.13954 10.7175 9.93071C11.5087 10.7219 11.9531 11.7949 11.9531 12.9138V38.2263H6.32812C5.5822 38.2263 4.86683 37.93 4.33939 37.4026C3.81194 36.8751 3.51563 36.1597 3.51562 35.4138V12.9138C3.51563 11.7949 3.9601 10.7219 4.75127 9.93071C5.54244 9.13954 6.61549 8.69507 7.73438 8.69507Z"
      fill="#4285F4"
    />
    <path
      d="M3.5793 12.303C3.59167 12.2186 3.59069 12.1324 3.60827 12.0482C3.63527 11.9191 3.68547 11.7999 3.724 11.6753C3.76135 11.5327 3.80632 11.3923 3.85872 11.2545C3.88684 11.1877 3.93016 11.1291 3.96222 11.0641C4.04966 10.8766 4.15091 10.6958 4.26513 10.5233C4.32138 10.4416 4.39169 10.372 4.45384 10.2946C4.56046 10.154 4.67572 10.0202 4.79894 9.89397C4.89245 9.80298 4.99905 9.7269 5.10086 9.64492C5.20888 9.55224 5.32153 9.46508 5.43836 9.38378C5.54988 9.31094 5.67194 9.25483 5.78992 9.19267C5.91185 9.1237 6.03716 9.06091 6.16539 9.00451C6.29055 8.95417 6.42386 8.92211 6.55436 8.88372C6.68486 8.84533 6.81494 8.79934 6.94909 8.77445C7.1153 8.74776 7.28294 8.73086 7.45113 8.72383C7.558 8.71637 7.66361 8.69767 7.77077 8.69851C7.9697 8.7043 8.16797 8.72428 8.36406 8.75828C8.44324 8.77009 8.52297 8.76911 8.60172 8.78542C8.73784 8.8201 8.87208 8.86178 9.00391 8.9103C9.13647 8.94553 9.26718 8.9874 9.39555 9.03573C9.46783 9.06667 9.53125 9.11265 9.60156 9.14753C9.78385 9.23317 9.95971 9.33186 10.1278 9.44284C10.6912 9.82969 11.1519 10.3478 11.4703 10.9526C11.7887 11.5573 11.955 12.2305 11.9551 12.9139V21.0167L5.31756 16.3703C4.66587 15.9327 4.1549 15.3158 3.84642 14.5939C3.53793 13.8721 3.44515 13.0764 3.5793 12.303Z"
      fill="#C52528"
    />
  </svg>
);

export const ColorLinkedInSvgIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="30"
    height="30"
    viewBox="0 0 48 48"
  >
    <path
      fill="#0078d4"
      d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5	V37z"
    ></path>
    <path
      d="M30,37V26.901c0-1.689-0.819-2.698-2.192-2.698c-0.815,0-1.414,0.459-1.779,1.364	c-0.017,0.064-0.041,0.325-0.031,1.114L26,37h-7V18h7v1.061C27.022,18.356,28.275,18,29.738,18c4.547,0,7.261,3.093,7.261,8.274	L37,37H30z M11,37V18h3.457C12.454,18,11,16.528,11,14.499C11,12.472,12.478,11,14.514,11c2.012,0,3.445,1.431,3.486,3.479	C18,16.523,16.521,18,14.485,18H18v19H11z"
      opacity=".05"
    ></path>
    <path
      d="M30.5,36.5v-9.599c0-1.973-1.031-3.198-2.692-3.198c-1.295,0-1.935,0.912-2.243,1.677	c-0.082,0.199-0.071,0.989-0.067,1.326L25.5,36.5h-6v-18h6v1.638c0.795-0.823,2.075-1.638,4.238-1.638	c4.233,0,6.761,2.906,6.761,7.774L36.5,36.5H30.5z M11.5,36.5v-18h6v18H11.5z M14.457,17.5c-1.713,0-2.957-1.262-2.957-3.001	c0-1.738,1.268-2.999,3.014-2.999c1.724,0,2.951,1.229,2.986,2.989c0,1.749-1.268,3.011-3.015,3.011H14.457z"
      opacity=".07"
    ></path>
    <path
      fill="#fff"
      d="M12,19h5v17h-5V19z M14.485,17h-0.028C12.965,17,12,15.888,12,14.499C12,13.08,12.995,12,14.514,12	c1.521,0,2.458,1.08,2.486,2.499C17,15.887,16.035,17,14.485,17z M36,36h-5v-9.099c0-2.198-1.225-3.698-3.192-3.698	c-1.501,0-2.313,1.012-2.707,1.99C24.957,25.543,25,26.511,25,27v9h-5V19h5v2.616C25.721,20.5,26.85,19,29.738,19	c3.578,0,6.261,2.25,6.261,7.274L36,36L36,36z"
    ></path>
  </svg>
);

export const BlackColorLinkedInSvgIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="24"
    height="24"
    viewBox="0 0 50 50"
  >
    <path d="M41,4H9C6.24,4,4,6.24,4,9v32c0,2.76,2.24,5,5,5h32c2.76,0,5-2.24,5-5V9C46,6.24,43.76,4,41,4z M17,20v19h-6V20H17z M11,14.47c0-1.4,1.2-2.47,3-2.47s2.93,1.07,3,2.47c0,1.4-1.12,2.53-3,2.53C12.2,17,11,15.87,11,14.47z M39,39h-6c0,0,0-9.26,0-10 c0-2-1-4-3.5-4.04h-0.08C27,24.96,26,27.02,26,29c0,0.91,0,10,0,10h-6V20h6v2.56c0,0,1.93-2.56,5.81-2.56 c3.97,0,7.19,2.73,7.19,8.26V39z"></path>
  </svg>
);

export const BlackColorFacebookSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="24"
    height="24"
    viewBox="0 0 50 50"
  >
    <path d="M25,3C12.85,3,3,12.85,3,25c0,11.03,8.125,20.137,18.712,21.728V30.831h-5.443v-5.783h5.443v-3.848 c0-6.371,3.104-9.168,8.399-9.168c2.536,0,3.877,0.188,4.512,0.274v5.048h-3.612c-2.248,0-3.033,2.131-3.033,4.533v3.161h6.588 l-0.894,5.783h-5.694v15.944C38.716,45.318,47,36.137,47,25C47,12.85,37.15,3,25,3z"></path>
  </svg>
);

export const ColorFacebookSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="30"
    height="30"
    viewBox="0 0 48 48"
  >
    <linearGradient
      id="Ld6sqrtcxMyckEl6xeDdMa_uLWV5A9vXIPu_gr1"
      x1="9.993"
      x2="40.615"
      y1="9.993"
      y2="40.615"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#2aa4f4"></stop>
      <stop offset="1" stop-color="#007ad9"></stop>
    </linearGradient>
    <path
      fill="url(#Ld6sqrtcxMyckEl6xeDdMa_uLWV5A9vXIPu_gr1)"
      d="M24,4C12.954,4,4,12.954,4,24s8.954,20,20,20s20-8.954,20-20S35.046,4,24,4z"
    ></path>
    <path
      fill="#fff"
      d="M26.707,29.301h5.176l0.813-5.258h-5.989v-2.874c0-2.184,0.714-4.121,2.757-4.121h3.283V12.46 c-0.577-0.078-1.797-0.248-4.102-0.248c-4.814,0-7.636,2.542-7.636,8.334v3.498H16.06v5.258h4.948v14.452 C21.988,43.9,22.981,44,24,44c0.921,0,1.82-0.084,2.707-0.204V29.301z"
    ></path>
  </svg>
);

export const BlackColorTwitterSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="24"
    height="24"
    viewBox="0 0 50 50"
  >
    <path d="M 11 4 C 7.134 4 4 7.134 4 11 L 4 39 C 4 42.866 7.134 46 11 46 L 39 46 C 42.866 46 46 42.866 46 39 L 46 11 C 46 7.134 42.866 4 39 4 L 11 4 z M 13.085938 13 L 21.023438 13 L 26.660156 21.009766 L 33.5 13 L 36 13 L 27.789062 22.613281 L 37.914062 37 L 29.978516 37 L 23.4375 27.707031 L 15.5 37 L 13 37 L 22.308594 26.103516 L 13.085938 13 z M 16.914062 15 L 31.021484 35 L 34.085938 35 L 19.978516 15 L 16.914062 15 z"></path>
  </svg>
);

export const ColorTwitterSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="30"
    height="30"
    viewBox="0 0 64 64"
  >
    <linearGradient
      id="HOaxCdew_So_FZGl4pPQ6a_bG29Ckcdp6YP_gr1"
      x1="32"
      x2="32"
      y1="9"
      y2="55"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#1a6dff"></stop>
      <stop offset="1" stop-color="#c822ff"></stop>
    </linearGradient>
    <path
      fill="url(#HOaxCdew_So_FZGl4pPQ6a_bG29Ckcdp6YP_gr1)"
      d="M49,55H15c-3.309,0-6-2.691-6-6V15c0-3.309,2.691-6,6-6h34c3.309,0,6,2.691,6,6v34	C55,52.309,52.309,55,49,55z M15,11c-2.206,0-4,1.794-4,4v34c0,2.206,1.794,4,4,4h34c2.206,0,4-1.794,4-4V15c0-2.206-1.794-4-4-4H15	z"
    ></path>
    <linearGradient
      id="HOaxCdew_So_FZGl4pPQ6b_bG29Ckcdp6YP_gr2"
      x1="32"
      x2="32"
      y1="13"
      y2="51"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#6dc7ff"></stop>
      <stop offset="1" stop-color="#e6abff"></stop>
    </linearGradient>
    <path
      fill="url(#HOaxCdew_So_FZGl4pPQ6b_bG29Ckcdp6YP_gr2)"
      d="M26.978,22l14.108,20h-3.063L23.914,22H26.978z M51,15v34c0,1.1-0.9,2-2,2H15	c-1.1,0-2-0.9-2-2V15c0-1.1,0.9-2,2-2h34C50.1,13,51,13.9,51,15z M44.914,44L34.789,29.613L43,20h-2.5l-6.841,8.009L28.022,20	h-7.937l9.222,13.103L20,44h2.5l7.937-9.292L36.978,44H44.914z"
    ></path>
  </svg>
);

export const BlackColorInstSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="24"
    height="24"
    viewBox="0 0 50 50"
  >
    <path d="M 16 3 C 8.83 3 3 8.83 3 16 L 3 34 C 3 41.17 8.83 47 16 47 L 34 47 C 41.17 47 47 41.17 47 34 L 47 16 C 47 8.83 41.17 3 34 3 L 16 3 z M 37 11 C 38.1 11 39 11.9 39 13 C 39 14.1 38.1 15 37 15 C 35.9 15 35 14.1 35 13 C 35 11.9 35.9 11 37 11 z M 25 14 C 31.07 14 36 18.93 36 25 C 36 31.07 31.07 36 25 36 C 18.93 36 14 31.07 14 25 C 14 18.93 18.93 14 25 14 z M 25 16 C 20.04 16 16 20.04 16 25 C 16 29.96 20.04 34 25 34 C 29.96 34 34 29.96 34 25 C 34 20.04 29.96 16 25 16 z"></path>
  </svg>
);

export const ColorInstaSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="30"
    height="30"
    viewBox="0 0 48 48"
  >
    <radialGradient
      id="yOrnnhliCrdS2gy~4tD8ma_Xy10Jcu1L2Su_gr1"
      cx="19.38"
      cy="42.035"
      r="44.899"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#fd5"></stop>
      <stop offset=".328" stop-color="#ff543f"></stop>
      <stop offset=".348" stop-color="#fc5245"></stop>
      <stop offset=".504" stop-color="#e64771"></stop>
      <stop offset=".643" stop-color="#d53e91"></stop>
      <stop offset=".761" stop-color="#cc39a4"></stop>
      <stop offset=".841" stop-color="#c837ab"></stop>
    </radialGradient>
    <path
      fill="url(#yOrnnhliCrdS2gy~4tD8ma_Xy10Jcu1L2Su_gr1)"
      d="M34.017,41.99l-20,0.019c-4.4,0.004-8.003-3.592-8.008-7.992l-0.019-20	c-0.004-4.4,3.592-8.003,7.992-8.008l20-0.019c4.4-0.004,8.003,3.592,8.008,7.992l0.019,20	C42.014,38.383,38.417,41.986,34.017,41.99z"
    ></path>
    <radialGradient
      id="yOrnnhliCrdS2gy~4tD8mb_Xy10Jcu1L2Su_gr2"
      cx="11.786"
      cy="5.54"
      r="29.813"
      gradientTransform="matrix(1 0 0 .6663 0 1.849)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#4168c9"></stop>
      <stop offset=".999" stop-color="#4168c9" stop-opacity="0"></stop>
    </radialGradient>
    <path
      fill="url(#yOrnnhliCrdS2gy~4tD8mb_Xy10Jcu1L2Su_gr2)"
      d="M34.017,41.99l-20,0.019c-4.4,0.004-8.003-3.592-8.008-7.992l-0.019-20	c-0.004-4.4,3.592-8.003,7.992-8.008l20-0.019c4.4-0.004,8.003,3.592,8.008,7.992l0.019,20	C42.014,38.383,38.417,41.986,34.017,41.99z"
    ></path>
    <path
      fill="#fff"
      d="M24,31c-3.859,0-7-3.14-7-7s3.141-7,7-7s7,3.14,7,7S27.859,31,24,31z M24,19c-2.757,0-5,2.243-5,5	s2.243,5,5,5s5-2.243,5-5S26.757,19,24,19z"
    ></path>
    <circle cx="31.5" cy="16.5" r="1.5" fill="#fff"></circle>
    <path
      fill="#fff"
      d="M30,37H18c-3.859,0-7-3.14-7-7V18c0-3.86,3.141-7,7-7h12c3.859,0,7,3.14,7,7v12	C37,33.86,33.859,37,30,37z M18,13c-2.757,0-5,2.243-5,5v12c0,2.757,2.243,5,5,5h12c2.757,0,5-2.243,5-5V18c0-2.757-2.243-5-5-5H18z"
    ></path>
  </svg>
);

export const GoogleSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="40"
    height="40"
    viewBox="0 0 48 48"
  >
    <path
      fill="#FFC107"
      d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
    ></path>
    <path
      fill="#FF3D00"
      d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
    ></path>
    <path
      fill="#4CAF50"
      d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
    ></path>
    <path
      fill="#1976D2"
      d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
    ></path>
  </svg>
);

export const Office365Svg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="40"
    height="40"
    viewBox="0 0 48 48"
  >
    <path
      fill="#e64a19"
      d="M7 12L29 4 41 7 41 41 29 44 7 36 29 39 29 10 15 13 15 33 7 36z"
    ></path>
  </svg>
);

export const VariablLightSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#FF3301"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="feather feather-zap"
  >
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
  </svg>
);

export const PlusCircleSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#FF3301"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="feather feather-plus"
  >
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </svg>
);
